import { getIn } from "formik";

const DateInput = ({ name, disabled, formik, label }) => {
  const required = Object.keys(formik.initialValues).some((key) => key === name);
  const nestedError = getIn(formik.errors, name);
  const nestedTouched = getIn(formik.touched, name);

  const handleChange = (e) => {
    formik.setFieldValue(name, e.target.value);
  };

  return (
    <div className="relative w-full mb-4 dark:text-white">
      {label && (
        <label className="block mb-1 font-medium capitalize dark:text-white">
          {label}
          {label && required && <span className="text-mainRed"> * </span>}
        </label>
      )}
      <input
        type="date"
        name={name}
        value={getIn(formik.values, name) || ""}
        onChange={handleChange}
        onBlur={formik.handleBlur}
        disabled={disabled}
        className="border-[#E5E7EB] text-black w-full h-[40px] border rounded-[5px] px-2"
        autoComplete="off"
      />
      {!disabled && nestedError && nestedTouched && (
        <span className="text-[12px] w-full left-0 text-mainRed absolute bottom-[-16px]">
          {nestedError}
        </span>
      )}
    </div>
  );
};

export default DateInput;
